import React, { useEffect, useState, forwardRef } from "react";
import {
  AccordionSummary,
  Grid,
  Input,
  NativeSelect,
  Typography,
} from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Paper from "@material-ui/core/Paper";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import Loading from "../../../components/Loading";
import Header from "../../../layout/Header";
import Subheader from "../../../layout/Subheader";
import api from "../../../services/api";
import { handleErrorRequest } from "../../../utils/errorsValidation";
import * as S from "./style";
import { formatDateTimeToRender } from "../../../utils/functions";

export function TimeCardRegister({
  isModal = false,
  item = {},
  modalGoBackFunction = null,
}) {
  const classes = S.useStyles();
  const { id } = useParams();

  const [isLoading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isView, setIsView] = useState(false);
  const [colaboradores, setColaboradores] = useState([]);
  const [workedHours, setWorkedHours] = useState();
  const [cpf, setCpf] = useState();
  const [hourDiff, setHourDiff] = useState();
  const [workSchedule, setWorkSchedule] = useState();
  const [workHours, setWorkHours] = useState();
  const [isRegister, setIsRegister] = useState(false);
  const [getErros, setErros] = useState([]);
  const [leftHourColor, setLeftHourColor] = useState("#949494");

  const [formValues, setFormValues] = useState({
    dataPonto: null,
    loginId: 0,
    ponto1: null,
    ponto2: null,
    ponto3: null,
    ponto4: null,
    entradaManual: "Sim",
    motivoAusencia: 0,
    fechado: "Nao",
  });

  const setDateNTime = (dataPonto, dataHoras) => {
    const date = new Date(dataPonto).toISOString().split("T")[0];
    let hours = "00:00";
    if (dataHoras instanceof Date)
      hours = new Date(dataHoras).toTimeString().substr(0, 4);
    else hours = dataHoras;

    return `${date}T${hours}:00.000Z`;
  };

  const toISODateString = (date) => {
    return `${new Date(date).toISOString().split("T")[0]}`;
  };

  const updateProvider = async (payload) => {
    if (!payload.loginId) {
      toast.error("Informe o colaborador");
      return;
    }

    payload.dataPonto = toISODateString(payload.dataPonto);
    payload.entradaManual = 1;
    const payloadUpdate = {
      ...payload,
      ponto1: payload.ponto1
        ? setDateNTime(payload.dataPonto, payload.ponto1)
        : null,
      ponto2: payload.ponto2
        ? setDateNTime(payload.dataPonto, payload.ponto2)
        : null,
      ponto3: payload.ponto3
        ? setDateNTime(payload.dataPonto, payload.ponto3)
        : null,
      ponto4: payload.ponto4
        ? setDateNTime(payload.dataPonto, payload.ponto4)
        : null,
    };
    try {
      const response = await api.put("CartoesPontos", payloadUpdate);

      if (response.data.status !== "Sucesso") {
        if (response.data.resposta) {
          if (response.data.resposta.length > 0) {
            response.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
        return;
      }

      if (response.data.status !== "Inconsistencia") {
        toast.success("Cartão ponto alterado com sucesso!");
        payloadUpdate.dataPonto = new Date(response.data.resposta.dataPonto);
        payloadUpdate.dataAtualizacao = response.data.resposta.dataAtualizacao;
        setFormValues(payloadUpdate);
        if (payload.ponto1) {
          handleTimeValues("ponto1", payload.ponto1);
        }
        if (payload.ponto2) {
          handleTimeValues("ponto2", payload.ponto2);
        }
        if (payload.ponto3) {
          handleTimeValues("ponto3", payload.ponto3);
        }
        if (payload.ponto4) {
          handleTimeValues("ponto4", payload.ponto4);
        }
        if (isModal) {
          modalGoBackFunction();
        }
      } else {
        setFormValues((prev) => ({
          ...prev,
          dataPonto: new Date(payload.dataPonto + " 00:00"),
        }));
        handleErrorRequest(response);
      }
    } catch (error) {
      setFormValues((prev) => ({
        ...prev,
        dataPonto: new Date(payload.dataPonto + " 00:00"),
      }));

      if (error.response?.data?.status !== "Sucesso") {
        if (error.response?.data?.resposta) {
          if (error.response?.data?.resposta.length > 0) {
            error.response?.data?.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
        return;
      }

      setErros(handleErrorRequest(error));
    }
  };

  const createProvider = async (payload) => {
    if (!payload.loginId) {
      toast.error("Informe o colaborador");
      return;
    }

    try {
      payload.dataPonto = toISODateString(payload.dataPonto);
      payload.entradaManual = 1;
      const payloadPontos = {
        ...payload,
        ponto1: payload.ponto1
          ? setDateNTime(payload.dataPonto, payload.ponto1)
          : null,
        ponto2: payload.ponto2
          ? setDateNTime(payload.dataPonto, payload.ponto2)
          : null,
        ponto3: payload.ponto3
          ? setDateNTime(payload.dataPonto, payload.ponto3)
          : null,
        ponto4: payload.ponto4
          ? setDateNTime(payload.dataPonto, payload.ponto4)
          : null,
      };
      const response = await api.post("CartoesPontos", payloadPontos);

      if (response.data.status !== "Sucesso") {
        if (response.data.resposta) {
          if (response.data.resposta.length > 0) {
            response.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
        return;
      }

      if (response?.data?.status !== "Inconsistencia") {
        toast.success("Cartão ponto criado com sucesso!");
        setFormValues({
          dataPonto: new Date(),
          loginId: 0,
          ponto1: null,
          ponto2: null,
          ponto3: null,
          ponto4: null,
          entradaManual: 1,
          motivoAusencia: 0,
          fechado: "Nao",
        });
        setCpf(null);
        setWorkedHours("00:00");
        setWorkSchedule("00:00");
        setWorkHours(null);
        if (isModal) {
          modalGoBackFunction();
        }
      } else {
        setFormValues((prev) => ({
          ...prev,
          dataPonto: new Date(payload.dataPonto + " 00:00"),
        }));
        setErros(handleErrorRequest(response));
      }
    } catch (error) {
      setFormValues((prev) => ({
        ...prev,
        dataPonto: new Date(payload.dataPonto + " 00:00"),
      }));

      if (error.response?.data?.status !== "Sucesso") {
        if (error.response?.data?.resposta) {
          if (error.response?.data?.resposta.length > 0) {
            error.response?.data?.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
        return;
      }

      setErros(handleErrorRequest(error));
    }
  };

  const onSubmit = async () => {
    isRegister ? createProvider(formValues) : updateProvider(formValues);
  };

  const fetchProviders = async () => {
    try {
      const users = await api.get("Colaboradores/Consultar?status=Todos");
      setColaboradores(users.data.resposta);
      return users.data.resposta;
    } catch (error) {
      toast.error("Não foi possível buscar colaboradores");
    }
  };

  const getTime = (value) => {
    return new Date(value).toTimeString().substr(0, 5);
  };

  const fetchJornada = async (jornadaTrabalhoId, dataPonto) => {
    try {
      const response = await api.get(
        `JornadasTrabalhos/ConsultarId?id=${jornadaTrabalhoId}`
      );
      const jornada = response.data.resposta;
      setWorkSchedule(jornada);
      let workTime = "00:00";
      switch (new Date(dataPonto).getDay()) {
        case 0:
          workTime = null;
          break;
        case 1:
          workTime = jornada.segunda;
          break;
        case 2:
          workTime = jornada.terca;
          break;
        case 3:
          workTime = jornada.quarta;
          break;
        case 4:
          workTime = jornada.quinta;
          break;
        case 5:
          workTime = jornada.sexta;
          break;
        case 6:
          workTime = null;
          break;
      }
      setWorkHours(workTime);

      return workTime;
    } catch (error) {
      toast.error("Não foi possível buscar jornadas do colaborador");
    }
    return null;
  };

  const fetchPoints = async (pontoId, collaborators) => {
    if (!pontoId) return;

    setLoading(true);

    try {
      const response = await api.get(`CartoesPontos/ConsultarId?id=${pontoId}`);

      if (response?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(response?.data?.complemento?.mensagensBox);
      }

      if (response.data.status !== "Sucesso") {
        if (response.data.resposta) {
          if (response.data.resposta.length > 0) {
            response.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
        return;
      }

      if (response.data.resposta) {
        const pontos = response.data.resposta;

        const colaborador = collaborators.find(
          (item) => item.loginId === Number(pontos.loginId)
        );

        if (colaborador) {
          setCpf(colaborador.cpf);
        }

        setFormValues((prev) => ({
          ...prev,
          cartaoPontoId: Number(pontoId),
          loginId: pontos.loginId,
          ponto1: pontos.ponto1 ? getTime(pontos.ponto1) : null,
          ponto2: pontos.ponto2 ? getTime(pontos.ponto2) : null,
          ponto3: pontos.ponto3 ? getTime(pontos.ponto3) : null,
          ponto4: pontos.ponto4 ? getTime(pontos.ponto4) : null,
          dataPonto: new Date(pontos.dataPonto),
          motivoAusencia: findMotivoAusencia(pontos.motivoAusencia),
          dataAtualizacao: pontos.dataAtualizacao,
          dataRegistro: pontos.dataRegistro,
        }));

        const workTime = await fetchJornada(
          colaborador.jornadaTrabalhoId,
          pontos.dataPonto
        );

        calcHours(
          pontos.ponto1 ? getTime(pontos.ponto1) : null,
          pontos.ponto2 ? getTime(pontos.ponto2) : null,
          pontos.ponto3 ? getTime(pontos.ponto3) : null,
          pontos.ponto4 ? getTime(pontos.ponto4) : null,
          null,
          workTime
        );
      }
    } catch (error) {
      if (error.response.status === 403) {
        if (error.response.data && error.response.data?.complemento) {
          if (error.response.data.status !== "Sucesso") {
            if (error.response.data.resposta) {
              if (error.response.data.resposta.length > 0) {
                error.response.data.resposta.forEach((element) => {
                  toast.error(element.message);
                });
              }
            }

            setLoading(false);
            return;
          }
        }
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const calcMilisecondsDifference = (startDate, endDate) => {
    if (startDate && endDate) {
      const endTime =
        endDate instanceof Date
          ? endDate.getTime()
          : new Date(
              new Date(formValues.dataPonto).setHours(
                endDate.split(":")[0],
                endDate.split(":")[1],
                0
              )
            );

      const startTime =
        startDate instanceof Date
          ? startDate.getTime()
          : new Date(
              new Date(formValues.dataPonto).setHours(
                startDate.split(":")[0],
                startDate.split(":")[1],
                0
              )
            );
      return endTime - startTime;
    } else return 0;
  };

  const findMotivoAusencia = (motivoAusencia) => {
    switch (motivoAusencia) {
      case "SemAusencia":
        return 0;
      case "AusenciaJustificada":
        return 1;
      case "AusenciaJustificadaComAtestado":
        return 2;
      case "AusenciaNaoJustificada":
        return 3;
      case "Treinamento":
        return 4;
      case "Ferias":
        return 5;
      default:
        return 0;
    }
  };

  const getDateTimeFromMilliseconds = (millisecondsDiff) => {
    const date = new Date(null);
    if (millisecondsDiff.toString().includes("-")) {
      date.setTime(Number(millisecondsDiff.toString().replace("-", "")));
    } else {
      date.setTime(millisecondsDiff);
    }

    const time = date.toISOString().substr(11, 8);
    const hours = time.substr(0, 2);
    const minutes = time.substr(3, 2);
    const seconds = 0;

    return new Date(
      new Date(formValues.dataPonto).setHours(hours, minutes, seconds)
    );
  };

  const calcHours = (
    ponto1,
    ponto2,
    ponto3,
    ponto4,
    motivoAusencia = null,
    workTime = null
  ) => {
    if (
      (motivoAusencia === null &&
        formValues.motivoAusencia !== 0 &&
        formValues.motivoAusencia !== 3) ||
      (motivoAusencia && motivoAusencia !== 0 && motivoAusencia !== 3)
    ) {
      setHourDiff("00:00");
      setLeftHourColor("#949494");
      return;
    }

    const horasTrabalho = workTime != null ? workTime : workHours;
    let millisecondsDiff = 0;

    if (
      (ponto1 || formValues.ponto1) &&
      ponto1 !== "00:00" &&
      (ponto2 || formValues.ponto2) &&
      ponto2 !== "00:00"
    ) {
      millisecondsDiff = calcMilisecondsDifference(
        ponto1 !== null ? ponto1 : formValues.ponto1,
        ponto2 !== null ? ponto2 : formValues.ponto2
      );
    }

    if (
      (ponto3 || formValues.ponto3) &&
      ponto3 !== "00:00" &&
      (ponto4 || formValues.ponto4) &&
      ponto4 !== "00:00"
    ) {
      millisecondsDiff += calcMilisecondsDifference(
        ponto3 !== null ? ponto3 : formValues.ponto3,
        ponto4 !== null ? ponto4 : formValues.ponto4
      );
    }

    const workedDateTime = getDateTimeFromMilliseconds(millisecondsDiff);
    setWorkedHours(workedDateTime.toTimeString().substr(0, 5));

    if (workedDateTime.toTimeString().substr(0, 5) === "00:00") {
      setHourDiff(horasTrabalho);
    } else {
      const millisecondsLeft = calcMilisecondsDifference(
        horasTrabalho,
        workedDateTime
      );

      if (millisecondsLeft.toString().includes("-")) {
        setLeftHourColor("red");
      } else {
        setLeftHourColor("#949494");
      }

      setHourDiff(
        getDateTimeFromMilliseconds(millisecondsLeft)
          .toTimeString()
          .substr(0, 5)
      );
    }
  };

  const handleSelectCollaborator = async (e) => {
    if (Number(e.target.value) > 0) {
      const colaborador = colaboradores.find(
        (item) => item.loginId === Number(e.target.value)
      );
      setCpf(colaborador.cpf);
      setFormValues((prev) => ({
        ...prev,
        loginId: Number(e.target.value),
      }));

      await fetchJornada(colaborador.jornadaTrabalhoId, formValues.dataPonto);
    } else {
      setWorkSchedule("00:00");
      setWorkHours("00:00");
      setCpf(null);
      setFormValues((prev) => ({
        ...prev,
        loginId: 0,
      }));
    }
  };

  const handleSelectedDate = (event) => {
    setFormValues((prev) => ({
      ...prev,
      dataPonto: event,
    }));
    switch (event.getDay()) {
      case 0:
        setWorkHours(null);
        break;
      case 1:
        setWorkHours(workSchedule.segunda);
        break;
      case 2:
        setWorkHours(workSchedule.terca);
        break;
      case 3:
        setWorkHours(workSchedule.quarta);
        break;
      case 4:
        setWorkHours(workSchedule.quinta);
        break;
      case 5:
        setWorkHours(workSchedule.sexta);
        break;
      case 6:
        setWorkHours(null);
        break;
    }
  };

  const CustomDateInput = forwardRef(({ value, onClick }, ref) => (
    <>
      <input
        type='text'
        className={classes.inputSelectDate}
        value={value || ""}
        style={{ width: "70%" }}
        onClick={onClick}
        ref={ref}></input>
    </>
  ));

  const handleTimeValues = (field, value) => {
    try {
      value = value.replace(/[^0-9]/g, "");
      // value = value.replace(':', '');

      const hora = value.substr(0, 2);
      const minutos = value.substr(2, 2);

      if (value.length < 2) {
        value = value.substr(0, 2);
      } else if (value.length > 4) {
        value = hora + ":" + minutos;
        if (Number(hora) > 23) {
          toast.error("Horário inválido");
        }
        if (Number(minutos) > 59) {
          toast.error("Horário inválido");
        }
      } else if (value.length >= 3) {
        value = hora + ":" + minutos;
        if (Number(hora) > 23) {
          toast.error("Horário inválido");
        }
        if (Number(minutos) > 59) {
          toast.error("Horário inválido");
        }
      }

      setFormValues((prev) => ({
        ...prev,
        [field]: value,
      }));

      let date = new Date();
      if (value.replace(":", "").length === 4) {
        date = new Date(
          new Date(
            new Date(
              new Date(formValues.dataPonto).setHours(value.split(":")[0])
            ).setMinutes(value.split(":")[1])
          ).setSeconds(0)
        );
      } else {
        date = "00:00";
      }

      if (field === "ponto1") calcHours(date, null, null, null);
      if (field === "ponto2") calcHours(null, date, null, null);
      if (field === "ponto3") calcHours(null, null, date, null);
      if (field === "ponto4") calcHours(null, null, null, date);
    } catch (error) {
      console.log("Problema ao gerar horário", error);
    }
  };

  useEffect(async () => {
    const colaboradores = await fetchProviders();

    if (isModal) {
      setIsEditing(true);
      setIsRegister(true);
      setIsRegister(item.cartaoPontoId === 0);

      if (item.cartaoPontoId) {
        await fetchPoints(item.cartaoPontoId, colaboradores);
      } else {
        setFormValues((prev) => ({
          ...prev,
          dataPonto: new Date(item.dataPonto),
          loginId: item.colaboradorId,
          ponto1: item.ponto1,
          ponto2: item.ponto2,
          ponto3: item.ponto3,
          ponto4: item.ponto4,
          motivoAusencia: item.motivoAusencia,
        }));

        const colaborador = colaboradores.find(
          (collaboratorItem) =>
            collaboratorItem.loginId === Number(item.colaboradorId)
        );

        const workTime = await fetchJornada(
          colaborador.jornadaTrabalhoId,
          item.dataPonto
        );

        calcHours(
          item.ponto1 ? item.ponto1 : null,
          item.ponto2 ? item.ponto2 : null,
          item.ponto3 ? item.ponto3 : null,
          item.ponto4 ? item.ponto4 : null,
          null,
          workTime
        );

        if (colaborador) {
          setCpf(colaborador.cpf);
        }
      }
    } else if (id) {
      setIsEditing(window.location.pathname.includes("editar"));
      setIsView(window.location.pathname.includes("visualizar"));
      await fetchPoints(id, colaboradores);
    } else {
      setIsEditing(true);
      setIsRegister(true);
      setFormValues((prev) => ({
        ...prev,
        dataPonto: new Date(),
      }));
    }
  }, [id]);

  return (
    <div className={isModal ? classes.rootModal : classes.root}>
      {!isModal && <Header />}
      {isEditing ? (
        <Subheader
          title={`${
            isRegister
              ? "Cadastrando cartão ponto "
              : ` Atualizando cartão ponto - ${
                  new Date(formValues?.dataPonto).toLocaleDateString("pt-BR") ||
                  ""
                }`
          } `}
          back='/app/cartoes-ponto'
          loading={isLoading}
          submit={onSubmit}
          submitText={`${
            isModal ? "Gravar" : `${isRegister ? "Cadastrar" : "Atualizar"}`
          }`}
          isModal={isModal}
          onClickParam={modalGoBackFunction}
        />
      ) : (
        <Subheader
          back='/app/cartoes-ponto'
          loading={isLoading}
          title={`Visualizando Cartão Ponto -  ${
            new Date(formValues?.dataPonto).toLocaleDateString("pt-BR") || ""
          }`}
          isModal={isModal}
          onClickParam={modalGoBackFunction}
        />
      )}
      <div className={classes.content}>
        <div className={isModal ? classes.rootFormModal : classes.rootForm}>
          {isLoading ? (
            <Loading />
          ) : (
            <div>
              <form onSubmit={onSubmit}>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    className={classes.summary}>
                    <Typography className={classes.heading}>
                      Informações
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      <Grid item xs={3}>
                        <label className={classes.label}>Colaborador</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            onChange={async (e) =>
                              await handleSelectCollaborator(e)
                            }
                            className={classes.input}
                            disabled={id > 0 || isModal}
                            value={formValues?.loginId}
                            name='colaboradorId'
                            error={getErros.includes("colaboradorId")}
                            onBlur={(event) =>
                              getErros.includes("colaboradorId") &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== "colaboradorId";
                                })
                              )
                            }>
                            <option value='0'>FALTA PREENCHER</option>
                            {colaboradores.map((colaborador) => (
                              <option
                                key={colaborador.loginId}
                                value={colaborador.loginId}>
                                {colaborador.nome}
                              </option>
                            ))}
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={5}>
                        <label className={classes.label}>CPF</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            style={{ textTransform: "uppercase !important" }}
                            className={classes.input}
                            classes={{ input: classes.inputText }}
                            placeholder='CPF'
                            value={cpf || ""}
                            disabled={true}
                            inputProps={{
                              minLength: 3,
                              maxLength: 150,
                            }}
                          />
                        </Paper>
                      </Grid>

                      <Grid container>
                        <Grid item xs={1}>
                          <label className={classes.label}>Data</label>
                          <Paper className={classes.medium} elevation={0}>
                            <DatePicker
                              disabled={id > 0 || formValues?.loginId === 0}
                              selected={formValues?.dataPonto || ""}
                              onChange={(e) => handleSelectedDate(e)}
                              dateFormat='dd/MM/yyyy'
                              locale='ptBR'
                              customInput={<CustomDateInput />}
                            />
                          </Paper>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item xs={1}>
                          <label className={classes.label}>Entrada</label>
                          <Paper className={classes.small} elevation={0}>
                            <Input
                              style={{ textTransform: "uppercase !important" }}
                              className={classes.inputTime}
                              classes={{ input: classes.inputText }}
                              disabled={!formValues?.loginId || isView}
                              placeholder='00:00'
                              value={formValues?.ponto1 || ""}
                              onChange={(e) => {
                                handleTimeValues("ponto1", e.target.value);
                              }}
                              onBlur={(e) => {
                                handleTimeValues("ponto1", e.target.value);
                              }}
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={1}>
                          <label className={classes.label}>Saida Almoço</label>
                          <Paper className={classes.small} elevation={0}>
                            <Input
                              style={{ textTransform: "uppercase !important" }}
                              className={classes.inputTime}
                              disabled={!formValues?.loginId || isView}
                              classes={{ input: classes.inputText }}
                              placeholder='00:00'
                              value={formValues?.ponto2 || ""}
                              onChange={(e) => {
                                handleTimeValues("ponto2", e.target.value);
                              }}
                              onBlur={(e) => {
                                handleTimeValues("ponto2", e.target.value);
                              }}
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={1}>
                          <label className={classes.label}>
                            Retorno Almoço
                          </label>
                          <Paper className={classes.small} elevation={0}>
                            <Input
                              style={{ textTransform: "uppercase !important" }}
                              className={classes.inputTime}
                              classes={{ input: classes.inputText }}
                              disabled={!formValues?.loginId || isView}
                              placeholder='00:00'
                              value={formValues?.ponto3 || ""}
                              onChange={(e) => {
                                handleTimeValues("ponto3", e.target.value);
                              }}
                              onBlur={(e) => {
                                handleTimeValues("ponto3", e.target.value);
                              }}
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={1}>
                          <label className={classes.label}>Saída</label>
                          <Paper className={classes.small} elevation={0}>
                            <Input
                              style={{ textTransform: "uppercase !important" }}
                              className={classes.inputTime}
                              classes={{ input: classes.inputText }}
                              disabled={!formValues?.loginId || isView}
                              placeholder='00:00'
                              value={formValues?.ponto4 || ""}
                              onChange={(e) => {
                                handleTimeValues("ponto4", e.target.value);
                              }}
                              onBlur={(e) => {
                                handleTimeValues("ponto4", e.target.value);
                              }}
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={1}>
                          <label className={classes.label}>Carga horária</label>
                          <Paper className={classes.small} elevation={0}>
                            <Input
                              style={{ textTransform: "uppercase !important" }}
                              className={classes.inputTime}
                              classes={{ input: classes.inputText }}
                              placeholder='00:00'
                              disabled
                              value={workHours || ""}
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={1}>
                          <label className={classes.label}>
                            Horas Tabalhadas
                          </label>
                          <Paper className={classes.small} elevation={0}>
                            <Input
                              style={{ textTransform: "uppercase !important" }}
                              className={classes.inputTime}
                              classes={{ input: classes.inputText }}
                              placeholder='00:00'
                              disabled
                              value={workedHours || ""}
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={1}>
                          <label className={classes.label}>Sobra/Falta</label>
                          <Paper className={classes.small} elevation={0}>
                            <Input
                              id='leftHour'
                              style={{
                                textTransform: "uppercase !important",
                                color: leftHourColor,
                              }}
                              className={classes.inputTime}
                              classes={{ input: classes.inputText }}
                              placeholder='00:00'
                              disabled
                              value={hourDiff || ""}
                            />
                          </Paper>
                        </Grid>
                      </Grid>

                      <Grid item xs={7}>
                        <label className={classes.label}>Motivo Ausencia</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={formValues?.motivoAusencia}
                            disabled={!isEditing}
                            name='motivoAusencia'
                            onChange={(e) => {
                              setFormValues((val) => ({
                                ...val,
                                motivoAusencia: Number(e.target.value),
                              }));

                              if (
                                e.target.value !== "0" &&
                                e.target.value !== "3"
                              ) {
                                setHourDiff("00:00");
                                setLeftHourColor("#949494");
                              } else {
                                calcHours(
                                  formValues.ponto1 ? formValues.ponto1 : null,
                                  formValues.ponto2 ? formValues.ponto2 : null,
                                  formValues.ponto3 ? formValues.ponto3 : null,
                                  formValues.ponto4 ? formValues.ponto4 : null,
                                  Number(e.target.value),
                                  null
                                );
                              }
                            }}
                            error={getErros.includes("motivoAusencia")}
                            onBlur={(event) =>
                              getErros.includes("motivoAusencia") &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== "motivoAusencia";
                                })
                              )
                            }>
                            <option value='0'>Sem Ausência</option>
                            <option value='1'>Ausência Justificada</option>
                            <option value='2'>Ausência Justificada com Atestado</option>
                            <option value='3'>Ausência Não Justificada</option>
                            <option value='4'>Treinamento</option>
                            <option value='5'>Ferias</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                {!isRegister ? (
                  <Accordion defaultExpanded>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls='panel1a-content'
                      id='panel1a-header'
                      className={classes.summary}>
                      <Typography className={classes.heading}>
                        Dados do Registro
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.details}>
                      <Grid container>
                        <Grid item xs={6}>
                          <label className={classes.label}>
                            Data de Registro
                          </label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              className={classes.input}
                              value={
                                formValues.dataRegistro &&
                                formatDateTimeToRender(formValues.dataRegistro)
                              }
                              readOnly
                              disabled={!isEditing}
                              placeholder='Data do Registro'
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={6}>
                          <label className={classes.label}>
                            Data da Atualização
                          </label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              className={classes.input}
                              value={
                                formValues.dataAtualizacao
                                  ? formatDateTimeToRender(
                                      formValues.dataAtualizacao
                                    )
                                  : ""
                              }
                              readOnly
                              disabled={!isEditing}
                              placeholder='Data da Atualização'
                            />
                          </Paper>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                ) : (
                  ""
                )}

                {isModal === false && (isRegister || isEditing) && (
                  <div className={classes.divButton}>
                    <button
                      variant='contained'
                      type='button'
                      onClick={onSubmit}
                      className={classes.button}>
                      {`${
                        isModal
                          ? "Gravar"
                          : `${isRegister ? "Cadastrar" : "Atualizar"}`
                      }`}
                    </button>
                  </div>
                )}
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
